import { api } from '@/lib/api';
import type {
  LeadRoutingRuleResponse,
  CreateLeadRoutingRuleRequest,
  UpdateLeadRoutingRuleRequest,
} from '@troia-v3/types';

/**
 * Lead Routing Rules API Service
 * Handles all lead routing rules API calls
 */
export const leadRoutingRulesApi = {
  /**
   * Get routing rules by funnel ID
   */
  async getByFunnelId(funnelId: string): Promise<LeadRoutingRuleResponse[]> {
    const response = await api.get<{ success: boolean; data: LeadRoutingRuleResponse[] }>(
      `leads-routing-rules/by-funnel/${funnelId}`
    );
    return response.data.data;
  },

  /**
   * Create a new routing rule
   */
  async create(data: CreateLeadRoutingRuleRequest): Promise<LeadRoutingRuleResponse> {
    const response = await api.post<{ success: boolean; data: LeadRoutingRuleResponse }>(
      'leads-routing-rules',
      data
    );
    return response.data.data;
  },

  /**
   * Update a routing rule
   */
  async update(id: string, data: UpdateLeadRoutingRuleRequest): Promise<LeadRoutingRuleResponse> {
    const response = await api.put<{ success: boolean; data: LeadRoutingRuleResponse }>(
      `leads-routing-rules/${id}`,
      data
    );
    return response.data.data;
  },

  /**
   * Delete a routing rule
   */
  async delete(id: string): Promise<void> {
    await api.delete(`leads-routing-rules/${id}`);
  },

  /**
   * Activate a routing rule
   */
  async activate(id: string): Promise<LeadRoutingRuleResponse> {
    const response = await api.post<{ success: boolean; data: LeadRoutingRuleResponse }>(
      `leads-routing-rules/${id}/activate`
    );
    return response.data.data;
  },

  /**
   * Deactivate a routing rule
   */
  async deactivate(id: string): Promise<LeadRoutingRuleResponse> {
    const response = await api.post<{ success: boolean; data: LeadRoutingRuleResponse }>(
      `leads-routing-rules/${id}/deactivate`
    );
    return response.data.data;
  },
};
